<template>
  <a-modal :title="title"
    width="92%"
    wrapClassName="global-modal-class export-modal-container"
    v-model:visible="innerVisible"
    :maskClosable="false"
    destroyOnClose
    centered
    :footer="null"
    @cancel="handleCancel">

    <div class="export-modal-content-container">
      <TipParagraph>
        <template #tip-title>
          用户可自定义需要导出的字段和字段顺序，导出后可在
          <img :src="asyncIcon" alt="" style="width: 22px;display: inline-block;vertical-align: middle;">
          处理记录中查看导出结果
        </template>
      </TipParagraph>

      <div class="export-modal-content">
        <div class="left-part">
          <AllOptionsWithSearch v-model:selected="selectedOptions"
            v-model:fileForm="fileForm"
            :options="allOptions"
            :fileFormatList="fileFormatList"
            :showMarkedStatus="showMarkedStatus"
            @fileFormatChange="fileFormatChange"
            @optionSelected="optionSelected">
          </AllOptionsWithSearch>

        </div>
        <div class="right-part">
          <SelectedSortedOptions v-model:options="selectedOptions"
            v-model:selectedCount="hasChosenCount"
            ref="selectedSortedRef">
          </SelectedSortedOptions>
        </div>
      </div>
    </div>
    <div class="popover-footer">
      <div class="footer-container">
        <a-button @click="resetDefaultValue">恢复默认</a-button>
        <div>
          <a-button key="back" class="cancel-btn" @click="handleCancel">取消</a-button>
          <a-button key="confirm" type="primary" :disabled="btnDisabled" @click="handleConfirm">确定</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import TipParagraph from '/@/components/TipParagraph.vue';
import AllOptionsWithSearch from './AllOptionsWithSearch.vue';
import SelectedSortedOptions from './SelectedSortedOptions.vue';
import asyncIcon from "/@/assets/images/async_icon.png"
import { getCustomExportOptions } from '../api';
import { cloneDeep } from 'lodash-es';
import { getTenantId } from '/@/utils/auth';

const emit = defineEmits(['update:visible', 'updateData', 'cancel', 'confirm']);
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  queryParams: {
    type: Function,
    required: false,
  }, 
  title: {
    type: String,
    required: false,
    default: '导出',
  },
  showMarkedStatus: {
    type: Boolean,
    default: false,
  }
})

const innerVisible = computed(() => props.visible);

const selectedSortedRef = ref();

const hasChosenCount = ref(0);

const selectedOptions = ref([]);
const allOptions = ref([])
const fileFormatList = ref([])
let defaultOptions = []
const fileFormat  = ref('')
const fileForm = ref()

const btnDisabled = computed(() => {
  if (allOptions.value.length === 0) return false
  return hasChosenCount.value == 0 && !['sourceFile', 'picture'].includes(fileFormat.value)
})

const handleCancel = () => {
  emit('cancel')
  emit('update:visible', false)
}

const handleConfirm = () => {
  emit('confirm', {
    ...fileForm.value,
    selected:selectedOptions.value
  })
}

const resetDefaultValue = () => {
  selectedOptions.value = cloneDeep(defaultOptions);
}

const queryCustomExportOptions = async () => {
  const params = {
    exportCode: props.type,
    tenantId: getTenantId(),
    fileFormat: fileFormat.value,
  }
  if (props.queryParams) {
    params.columnsConfig = props.queryParams();
    if (params.columnsConfig?.tenantId) {
      params.tenantId = params.columnsConfig.tenantId 
    }
  }
  const res = await getCustomExportOptions(params);
  if (res) {
    allOptions.value = res.sysExportNodeList || [];
    defaultOptions = res.sysDefaultExportNodeList || [];
    selectedOptions.value = cloneDeep(filterLastSavedOptions(res.userExportNodeList) || cloneDeep(defaultOptions))
    fileFormatList.value = res.sysExportFileFormatList?.map((item: any) => {
        return {
          label: item.fileFormatName,
          value: item.fileFormat,
          otherConfig: item.otherConfig,
        }
    }) ?? []
  }
}

// 根据可选字段做次过滤，因为上次保存的数据可能与本次请求的数据过滤规则不一致
const filterLastSavedOptions = (data) => {
  if (!data?.length) {
    return;
  }

  return data.filter(item => {
    if (!item) {
      return false;
    }

    const allOuterOptions = allOptions.value?.find(allOptionItem => allOptionItem.id === item.id);
    if (!allOuterOptions) {
      return false;
    }

    item.sysExportNodeColumnList = item.sysExportNodeColumnList?.filter(childItem => {
      return allOuterOptions.sysExportNodeColumnList.some(allInnerItem => allInnerItem.id === childItem.id);
    })

    return true;
  })
}

const fileFormatChange = (value) => { 
  fileFormat.value = value;
  queryCustomExportOptions()
}
const optionSelected = (nodeCode) => {
  selectedSortedRef.value?.showSomeEle(nodeCode);
}

onMounted(() => {
  queryCustomExportOptions()
})
</script>

<style lang="less" scoped>
.export-modal-content {
  display: flex;
  margin-top: 24px;
  height: 506px;
  overflow-y: auto;
  border: 1px solid #E8E8E8;
  .left-part {
    padding: 24px;
    width: 67%;
  }
  .right-part {
    padding: 24px;
    width: 33%;
    border-left: 2px solid #E9E9E9;
  }
}
.input-search {
  width: 260px;
  border-radius: 2px;
}
.export-modal-content-container {
  padding: 24px 32px;
}
.footer-container {
  border-top: 1px solid #E9E9E9;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
}
.cancel-btn {
  margin-right: 8px;
}
.content-title {
  color: #262626;
  font-size: 16px;
}
:deep(.ant-collapse) {
  border: none!important;
}
:deep(.ant-collapse-item) {
  border-bottom: none!important;
}
:deep(.ant-collapse-header) {
  background-color: #fff;
}
:deep(.ant-collapse-content) {
  background-color: #fff!important;
  border-top: none;
}
:deep(.all-check) {
  margin-bottom: 0;
}
</style>
